import React, { memo } from 'react'
import Link from 'next/link'
import Image from 'next/image'
// Utils
import styles from './blogPost.module.scss'
import { PostDataType } from '@types'

export const BlogPostCard = memo(({ post }: { post: PostDataType }) => {
  return (
    <div className={styles.card__Post}>
      <div className={styles.card__Post_image}>
        <Link href={`/blog/${post.slug}`} prefetch={false}>
          {post?.metadata?.image?.imgix_url ? (
            <Image
              src={post?.metadata?.image?.imgix_url}
              alt={post.title}
              height={170}
              width={254}
            />
          ) : (
            <div className={styles.card__Post_imagePlaceholder} />
          )}
        </Link>
      </div>

      <div className={styles.card__Post_wrapperInfo}>
        <div className={styles.card__Post_title}>
          <Link href={`/blog/${post.slug}`} prefetch={false}>
            {post.title}
          </Link>
        </div>

        <div className={styles.card__Post_time}>{post?.metadata?.reading_time} read</div>
        <div className={styles.card__Post_read}>
          <Link href={`/blog/${post.slug}`} prefetch={false}>
            Read article
          </Link>
        </div>
      </div>
    </div>
  )
})

export default BlogPostCard
